import React from 'react';
import { useGetIdentity } from '@refinedev/core';
import { User } from '@src/types';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router';
import { SmartDataTable } from '@src/components/SmartDataTable';
import { useUsersColumns } from './hooks/useUsersColumns';
import { useUsersFormFields } from './hooks/useUsersFormFields';
import { useUserCardView } from './hooks/useUserCardView';


export const UsersPage: React.FC = () => {
  const { data: user, isLoading } = useGetIdentity<User>();
  const navigate = useNavigate();
  const columns = useUsersColumns();
  const formFields = useUsersFormFields();
  const { UserCardView } = useUserCardView();


  // Check user access
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50vh',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <div>Loading...</div>
      </div>
    );
  }

  if (!['MASTER_ADMIN', 'ADMIN', 'DOCTOR'].includes(user?.type || '')) {
    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle="Sorry, you don't have permission to access the Users page. Only Master Admin, Admin, and Doctor users can access this feature."
        extra={[
          <Button
            type="primary"
            key="dashboard"
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </Button>,
        ]}
      />
    );
  }

  return (
    <SmartDataTable
      api={{
        resource: 'users',
      }}
      title="Users"
      columns={columns}
      search={{
        enabled: true,
        fields: ['first_name', 'last_name', 'email', 'mobile_no'],
        placeholder: 'Search by name, email, or mobile...',
        debounceMs: 500,
      }}
      createForm={{
        fields: formFields as any,
        title: 'Create User',
        submitText: 'Create User',
      }}
      editForm={{
        fields: formFields as any,
        title: 'Edit User',
        submitText: 'Save Changes',
      }}
      formDisplayMode="modal"
      showCreate={true}
      showEdit={true}
      showDelete={true}
      showView={false}
      pageSize={10}
      showSizeChanger={true}
      showQuickJumper={false}
      // showExport={true}
      showColumnVisibility={true}
      mobileCardComponent={UserCardView}
      tableProps={{
        scroll: {
          x: 'max-content',
          y: 'calc(100vh - 240px)',
        },
      }}
      rowKey="id"
    />
  );
};
